<template>
    <div id="config-dialog" class="config-dialog">
        <!-- 整个dialog -->
        <el-dialog
            title="文件转换"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            :before-close="handleClose"
        >
            <!-- 文件信息 -->
            <div class="file-info">
                <div class="top-title">文件名称</div>
                <div class="file-name">{{ fileName }}</div>
            </div>
            <!-- 配置列表组件 -->
            <configTabs :fileFormat="fileFormat" :key="tabsKey" ref="configTabs"></configTabs>
            <!-- dialog底部 -->
            <span slot="footer" class="dialog-footer">
                <!-- 底部按钮 -->
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="startConvert">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
// 引入常用方法
import { analysisFileType } from 'src/utils/commonUtils';
import { postJobConvertor } from 'src/utils/jobUtils';

// 引入组件
import configTabs from './configTabs';
export default {
    name: 'convertConfig',
    components: { configTabs },
    data() {
        return {
            dialogVisible: false, //是否展示dialog
            // 文件名与格式
            fileName: '',
            fileFormat: '',
            tabsKey: 0, // configTabs组件的key值，控制重复渲染
            convertConfig: null, // 请求体所需的参数
        };
    },
    methods: {
        open(fileName) {
            // 读取文件名与文件格式
            this.fileName = fileName;
            this.fileFormat = analysisFileType(fileName);

            // 更改key值，configTabs组件重新渲染
            this.tabsKey++;
            this.dialogVisible = true; //打开dialog
        },
        // 获取不同格式对应的jobType(除dwg的2d)
        getJobType(fileFormat, convertWay) {
            let tempConverters = this.$store.state.fileConvert.converterTypes[fileFormat].converters;
            for (let index = 0; index < tempConverters.length; index++) {
                let tempType = tempConverters[index].name.split('-');
                if (tempType[tempType.length - 1] === convertWay) {
                    return tempConverters[index].name;
                }
            }
        },
        // 获取dwg格式对应的jobType
        getDwgJobType(fileFormat, convertWay, viewType) {
            let tempConverters = this.$store.state.fileConvert.converterTypes[fileFormat].converters;
            for (let index = 0; index < tempConverters.length; index++) {
                let tempType = tempConverters[index].name.split('-');
                if (viewType === 'v2d') {
                    if (tempType[tempType.length - 1] === convertWay && tempType[0].indexOf('3d') === -1) {
                        return tempConverters[index].name;
                    }
                } else if (viewType === 'v3d') {
                    if (tempType[tempType.length - 1] === convertWay && tempType[0].indexOf('3d') !== -1) {
                        return tempConverters[index].name;
                    }
                }
            }
        },
        // 封装请求数据
        packRequestData() {
            const _configTabs = this.$refs.configTabs; // 取configTabs实例
            let jobType;
            if (this.fileFormat === 'dwg') {
                jobType = this.getDwgJobType(this.fileFormat, _configTabs.convertWay, _configTabs.dwgFormat.viewType);
            } else {
                jobType = this.getJobType(this.fileFormat, _configTabs.convertWay); // 获取当前所选配置的jobType
            }
            // 获取参数parameters
            let parameters = null;
            switch (this.fileFormat) {
                case 'rvt':
                    parameters = _configTabs.getRvtParameters();
                    break;
                case 'ifc':
                    parameters = _configTabs.getIfcParameters();
                    break;
                case 'nwd':
                    if(jobType === 'nwd-obv') {
                      parameters = _configTabs.getNwdParameters();
                    } else {
                      parameters = null;
                    }
                    break;
                case 'skp':
                    parameters = _configTabs.getSkpParameters();
                    break;
                default:
                    parameters = null;
                    break;
            }
            // 封装
            return {
                jobType,
                parameters,
            };
        },
        // 点击确定按钮开始转换、关闭dialog
        startConvert() {
            // 获取请求体
            this.convertConfig = this.packRequestData();
            // 发送转换请求
            const tempBucketKey = this.$store.state.storage.bucketKey;
            postJobConvertor(tempBucketKey, this.fileName, this.convertConfig)
                .then(() => {
                    this.$message('开始转换');
                    this.$emit('refreshFileListForSelect', tempBucketKey);
                    this.convertConfig = null; //释放对象所占空间
                })
                .catch((err) => {
                    this.$message.error('文件正在转换');
                });
            this.dialogVisible = false; //关闭dialog
        },
        // 点击关闭
        handleClose() {
            this.dialogVisible = false; //关闭dialog
        },
    },
};
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
#config-dialog >>>
  .el-dialog
    display flex
    flex-direction column
    width 672px
    margin 0 !important
    position absolute
    top 40%
    left 50%
    transform translate(-50%, -50%)
    .el-dialog__header
      border-bottom 1px solid #eee
      .el-dialog__title
        color #333
    .el-dialog__body
      flex 1
      padding-top 10px
      padding-bottom 20px
      overflow auto
.file-info
  margin-bottom 20px
  .top-title
    margin-bottom 10px
  .file-name
    border 1px solid #ccc
    padding 5px 12px
    line-height 32px
    -webkit-user-select text
</style>



// WEBPACK FOOTER //
// src/pages/devCenter/consoleLab/components/convertConfig.vue